import { Immutable } from "immer";
import React, { useEffect } from "react";

import type { ProductReviewForm as Value } from "@reactivated";

import { loadPowerReviews } from "../../utils/powerreviews";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/product_reviews/reviews_form.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null
 * on the standalone template path) and is ignored.
 *
 * The legacy template loaded the PowerReviews ui.js synchronously and called
 * ``POWERREVIEWS.display.render`` inline at parse time; loading it
 * post-hydration in an effect is the React equivalent and survives client
 * re-renders.
 */
export const ProductReviewForm = (_props: IProps): React.JSX.Element => {
    useEffect(() => {
        let cancelled = false;
        loadPowerReviews()
            .then((pr) => {
                if (cancelled) {
                    return;
                }
                pr.display.render({
                    api_key: "e1f8faa4-1490-4696-a021-a47cf58e9c25",
                    locale: "en_US",
                    merchant_group_id: "78466",
                    merchant_id: "183461",
                    // NOTE: page_id and page_id_variant are always specified
                    // in the query string instead (PowerReviews reads them
                    // from there), matching the legacy inline script.
                    components: {
                        Write: "pr-write",
                    },
                });
            })
            .catch(() => {
                // PowerReviews unavailable; the container stays empty, same
                // as the legacy script-error case.
            });
        return () => {
            cancelled = true;
        };
    }, []);
    return (
        <section className="reviews ptb">
            <div className="container">
                <div id="pr-write"></div>
            </div>
        </section>
    );
};
